/**
 * 区块链浏览器链接工具
 * 根据不同区块链类型生成对应的浏览器链接
 */

interface BlockchainExplorerConfig {
  [key: string]: {
    explorerUrl: string; // 浏览器基础URL
    txPath?: string;     // 交易hash路径（可选，默认为 '/tx/'）
  };
}

/**
 * 区块链浏览器配置
 * key 为区块链名称（不区分大小写）
 * 目前支持：ETH (Ethereum)、BSC (BNB Chain)、TRON
 */
const BLOCKCHAIN_EXPLORERS: BlockchainExplorerConfig = {
  // Ethereum 提现用
  'ETH': {
    explorerUrl: 'https://etherscan.io',
    txPath: '/tx/',
  },

  // BNB Chain 提现用
  'BSC': {
    explorerUrl: 'https://bscscan.com',
    txPath: '/tx/',
  },

  // TRON 链（Tronscan）
  'TRON': {
    explorerUrl: 'https://tronscan.org',
    txPath: '/#/transaction/',
  },

  // Ethereum 充值用
  'Ethereum': {
    explorerUrl: 'https://etherscan.io',
    txPath: '/tx/',
  },

  // BNB Chain 充值用
  'BNB Smart Chain': {
    explorerUrl: 'https://bscscan.com',
    txPath: '/tx/',
  },

  // TRON 充值用（与 TRON 同义）
  'Tron': {
    explorerUrl: 'https://tronscan.org',
    txPath: '/#/transaction/',
  },
};

/**
 * 根据区块链类型生成交易hash的浏览器链接
 * 
 * @param blockchain - 区块链类型（例如：Ethereum, TRON, BNB Chain 等）
 * @param txHash - 交易hash
 * @returns 区块链浏览器链接，如果 blockchain 未知则返回 null
 */
export const getBlockchainExplorerUrl = (
  blockchain: string,
  txHash: string
): string | null => {
  if (!blockchain || !txHash) {
    return null;
  }

  // 查找配置（不区分大小写）
  const blockchainUpper = blockchain.toUpperCase();
  const config = BLOCKCHAIN_EXPLORERS[blockchainUpper] ||
    BLOCKCHAIN_EXPLORERS[blockchain];

  if (!config) {
    console.warn(`Unknown blockchain: ${blockchain}`);
    return null;
  }

  const txPath = config.txPath || '/tx/';
  return `${config.explorerUrl}${txPath}${txHash}`;
};

/**
 * 打开区块链浏览器链接
 * 
 * @param blockchain - 区块链类型
 * @param txHash - 交易hash
 */
export const openBlockchainExplorer = (blockchain: string, txHash: string) => {
  const url = getBlockchainExplorerUrl(blockchain, txHash);
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

